<template v-if="configuration">
  <div class="ugc-terms-conditions-new-modal-form">
    <div class="ugc-terms-conditions-new-modal-form-main">
      <div class="row ugc-terms-conditions-new-modal-form-header-text">
      {{ translations.twoStepsTermsConditionModalHeaderText }}
      </div>
      <contact-form-new
        v-if="configuration.ugc.enableUGCContactDetails"
        report-field-blur
        @field-blur-event="resetScreenScrollPosition"
        @validity-update="updateContactFormValidity"
        @contact-details-update="contactDetailsUpdated"
      ></contact-form-new>

      <div class="row checkboxs">
        <label for="add-your-own-check">
          <input
            type="checkbox"
            name="add-your-own-check"
            class="add-your-own-check"
            :disabled="!enableIAgreeCheckbox || !!this.$cookies.get(sessionKeys.ugcTermsConditionsAccepted)"
            :checked="hasAcceptedTerms"
            @change="setUgcTermsConditionsCookie($event)"
            :aria-checked="hasAcceptedTerms" 
            aria-labelledby="customs-ugc-terms-checkbox"
          />
          <span id="customs-ugc-terms-checkbox" class="custom radio">{{ translations.twoStepsTermsConditionModalTermsLinkLabel }}
            <a
              :href="translations.termsConditionLink"
              target="_blank"
            >
              {{ translations.twoStepsTermsConditionModalTermsLinkText }}
            </a>
          </span>
        </label>

        <label for="newsletter-check" v-if="configuration.enableOptInCheckbox">
          <input
            type="checkbox"
            class="newsletter-check"
            :checked="(configuration.forceCheckedOptIn && !this.$cookies.get(sessionKeys.ugcOptIn)) || this.$cookies.get(sessionKeys.ugcOptIn)"
            @change="setUgcOptInCookie($event)"
          />
          <span class="custom radio">{{ translations.twoStepsTermsConditionModalTermsOptIn }}</span>
        </label>
      </div>
    </div>

    <ugcentrypoint-choose-image
      ref="chooseImage"
      v-if="useChooseImageComponent"
      :disabled="!enableChooseImageButton"
      inputLabel="ugcUpload"
    ></ugcentrypoint-choose-image>
    <ugc-image-upload
      v-else
      ref="imageUpload"
      @click="setDataLayer"
      :disable-button="!enableChooseImageButton"
      :displayIcon="true"
      inputLabel="ugcUpload"
      :forceUpload="hasAcceptedTerms"
    />

  </div>
</template>

<script>

import contactFormNew from '@/components/ContactFormNewWrapper';
import ugcImageUpload from '@/components/UGC/Tray/ImageUpload';
import ugcentrypointChooseImage from "@/components/UGCEntryPoint/ChooseImage";

import { sessionKeys } from '@/data/constants';

export default {
  components: {
    ugcImageUpload,
    contactFormNew,
    ugcentrypointChooseImage,
  },
  props: {
    useChooseImageComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sessionKeys,
      hasAcceptedTerms: false,
      isContactFormValid: false,
      contactDetails: {},
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    enableIAgreeCheckbox() {
      return this.isContactFormValid || !this.configuration.ugc.enableUGCContactDetails;
    },
    enableChooseImageButton() {
      return this.enableIAgreeCheckbox && this.hasAcceptedTerms;
    },
    checkerboarderActive() {
      return this.$store.state.UGCEntryPoint.checkerboarder.active;
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
  },
  watch: {
    enableChooseImageButton(enable) {
      this.$emit('blockCtaPrimaryButton', !enable);
    },
  },
  methods: {
    /**
     * @function resetScreenScrollPosition
     * Triggers the screen size calculations at Customizer.vue after the mobile keyboard is closed
     */
    resetScreenScrollPosition() {
      if (this.isMobile) this.$eventBus.$emit('recalculate-customizer-screen-size');
    },
    /**
     * @function setInitialData
     * Resets the data attributes used to control the state.
     */
    setInitialData() {
      this.hasAcceptedTerms = !!this.$cookies.get(this.sessionKeys.ugcTermsConditionsAccepted);
      this.isContactFormValid = !!this.$cookies.get(this.sessionKeys.ugcContactDetailsFilled);
      if (this.$cookies.get(this.sessionKeys.ugcOptIn) || (this.configuration.forceCheckedOptIn && !this.$cookies.get(this.sessionKeys.ugcOptIn))) {
        this.$store.commit('UGCEntryPoint/SET_OPT_IN', true);
      }
      if (this.isContactFormValid) {
        this.contactDetailsUpdated(this.$cookies.get(this.sessionKeys.ugcContactDetailsFilled));
      }
    },
    setDataLayer() {
      if (this.$ugcDataLayer && !this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$ugcDataLayer.logAnalyticsEvent({ type: this.$ugcDataLayer.types.chooseImage });
      }
      if (this.$ugcEntryPointDataLayer) {
        this.$ugcEntryPointDataLayer.logAnalyticsEvent({
          action: this.checkerboarderActive ? 'checkerboarder' : 'ugc',
          type: this.$ugcEntryPointDataLayer.types.chooseImage
        });
      }
    },
    ctaAction() {
      this.$emit('setActiveComponent', 'termsConditionsForm');
    },
    goBackAction() {
      this.$modal.hide('newTermsConditionModal');
    },
     /**
     * @function setUgcTermsConditionsCookie
     * Set the cookie when the input is checked. Otherwise the cookie will be removed.
     */
    setUgcTermsConditionsCookie(event) {
      this.hasAcceptedTerms = event ? event.target.checked : false;
      if (!this.useChooseImageComponent) {
        this.$refs['imageUpload'].setTermsConditionAccepted(this.hasAcceptedTerms);
      }
    },
    setUgcOptInCookie(event) {
      if (!event.target.checked) {
        this.$cookies.remove(this.sessionKeys.ugcOptIn);
      }
      this.$store.commit('UGCEntryPoint/SET_OPT_IN', event.target.checked);
    },
    validateText(key) {
      return this.translations[key] !== "";
    },
    updateContactFormValidity(isValid) {
      this.isContactFormValid = isValid;
    },
    contactDetailsUpdated(contactDetails) {
      this.contactDetails = {
        ...this.contactDetails,
        ...contactDetails
      };
      this.$store.commit('UGCEntryPoint/SET_CONTACT_DETAILS', this.contactDetails);
    }
  },
  created() {
    this.setInitialData();
    if (!this.$store.state.UGCEntryPoint.optIn) {
      this.$cookies.remove(this.sessionKeys.ugcOptIn);
    }
    this.$emit('showCtaButton', this.useChooseImageComponent);
    this.$emit('blockCtaPrimaryButton', !this.enableChooseImageButton);
    this.$emit('showBackButton', false);
    this.$emit('showIconButton', true);
  }
}
</script>
